import { css } from 'styled-components';

const ie = (...styles) => (
    css`@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        ${css(...styles)}
    }`
);

export default ie;